import * as React from 'react';

import DataLoader from '../../../common/loader/data-loader';

export interface IZoneUpsellProps {
    onCloseZoneUpsell: () => void;
    onUpsellClick: () => void;
    priceText: string;
    upsellMessage: string;
    loadingImage: boolean;
    mobileCartOpen: boolean;
    zoneUpsellSeatView: string;

    loadingSvgText: string;
    stopLoadingAnimationButtonText: string;
    upsellButtonText: string;
    zoneUpsellName: string;
}

class ZoneUpsellComponent extends React.PureComponent<IZoneUpsellProps, null>{
    render() {
        const {
            onCloseZoneUpsell,
            onUpsellClick,
            priceText,
            upsellMessage,
            loadingImage,
            mobileCartOpen,
            zoneUpsellSeatView,
            zoneUpsellName
        } = this.props;
        const useTagClose = '<use xlink:href="#icon-close" />';
        const useDollarIcon = '<use xlink:href="#icon-dollar" />';
        const useTagDownArrow = '<use xlink:href="#icon-arrow-down" />';
        var cartContainerClass = 'cart-container';

        return (
            <div className={"zone-upsell-container"}>
                <div className={"zone-upsell" + (mobileCartOpen ? "" : " collapsed")}>
                    <div className="zone-upsell-header">
                        <svg className="zone-upsell-header-icon"
                            dangerouslySetInnerHTML={{ __html: useDollarIcon }}  />

                        <span className="zone-upsell-header-msg">{upsellMessage}</span>
                        <button type="button" className="zone-upsell-close">
                            <svg className="zone-upsell-close-svg"
                                dangerouslySetInnerHTML={{ __html: useTagClose }}
                                onClick={onCloseZoneUpsell} />
                        </button>

                    </div>


                    <div className="zone-upsell-inner">
                        <div className="zone-upsell-display">
                            <div className="zone-upsell-content">
                                <div className="zone-upsell-content-info">
                                    <div className="zone-upsell-content-info-description">
                                        {zoneUpsellName}
                                    </div>
                                </div>

                                {(!loadingImage && zoneUpsellSeatView) &&
                                    <div className="zone-upsell-content-image zone-upsell-seat-view"
                                        style={{ backgroundImage: "url(" + zoneUpsellSeatView + ")" }}>
                                    </div>
                                }
                            </div>
                            <div className="zone-upsell-section">
                                <button className="zone-upsell-section-btn" onClick={onUpsellClick}>
                                    {this.props.upsellButtonText}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ZoneUpsellComponent;